import React from 'react'
import { Icon } from '../../../atoms/Icon'
import { AddNoteHeaderButtonProps } from './AddNoteHeaderButton.types'
import { AddNoteButton } from './AddNoteHeaderButton.styles'

export const AddNoteHeaderButton: React.FC<AddNoteHeaderButtonProps> = ({
  onClick,
  disabled = false,
  label = 'Add Note',
}) => {
  return (
    <AddNoteButton onClick={onClick} disabled={disabled} type="button">
      <Icon name="plus" size="small" />
      <span>{label}</span>
    </AddNoteButton>
  )
}
